import React, { Component } from 'react'
import Included from '../Included'
class Grid extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section>
      <a className="anchor" id="grid"></a>
      <h2>Grid</h2>
      <p>We are using a <a href="http://leejordan.github.io/reflex/docs/">flexbox 12 column based grid system</a> that should be relatively familiar if you have used another grid system.
        <br/> Though flexbox has <a href="http://caniuse.com/#search=flexbox">good support</a>, the grid will fallback to using inline-block to support older browsers.</p>

          <select className="size-select">
            <option value="auto">Select a resolution</option>
            <option value="483">480px (xs)</option>
            <option value="771">768px (sm)</option>
            <option value="995">992px (md)</option>
            <option value="1203">1200px (lg)</option>
          </select>
          <br/><br/>
          <div className="iframe-container" style={{"height":"347px"}}>
            <iframe seamless srcDoc={`
              <html>
                <head>
                  <link rel="stylesheet" type="text/css" href="css/commonUI.css">
                  <link rel="stylesheet" type="text/css" href="css/styleguide.css">
                </head>
                <body>
                  <div class="grid sample-grid"">
            <div class="grid__col-4">
              grid__col-4
            </div>
            <div class="grid__col-4">
              grid__col-4
            </div>
            <div class="grid__col-4">
              grid__col-4
            </div>
            <div class="grid__col-xs-4">
              grid__col-xs-4
            </div>
            <div class="grid__col-xs-8">
              grid__col-xs-8
            </div>
            <div class="grid__col-sm-6">
              grid__col-sm-6
            </div>
            <div class="grid__col-sm-6">
              grid__col-sm-6
            </div>
            <div class="grid__col-md-8">
              grid__col-md-8
            </div>
            <div class="grid__col-md-4">
              grid__col-md-4
            </div>
            <div class="grid__col-lg-4">
              grid__col-lg-4
            </div>
            <div class="grid__col-lg-8">
              grid__col-lg-8
            </div>
            </div>
                </body>
              </html>
            `}></iframe>
          </div>
      <br/>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="grid">
  <div class="grid__col-4">
    grid__col-4
  </div>
  <div class="grid__col-4">
    grid__col-4
  </div>
  <div class="grid__col-4">
    grid__col-5
  </div>
  <div class="grid__col-xs-4">
    grid__col-xs-4
  </div>
  <div class="grid__col-xs-8">
    grid__col-xs-8
  </div>
  <div class="grid__col-sm-6">
    grid__col-sm-6
  </div>
  <div class="grid__col-sm-6">
    grid__col-sm-6
  </div>
  <div class="grid__col-md-8">
    grid__col-md-8
  </div>
  <div class="grid__col-md-4">
    grid__col-md-4
  </div>
  <div class="grid__col-lg-4">
    grid__col-lg-4
  </div>
  <div class="grid__col-lg-8">
    grid__col-lg-8
  </div>
</div>`}</code></pre>
      <br/>
      <p>These modifier classes determine grid columns at various viewport sizes. A grid built using numbered columns in this way will remain fully intact in the inline-block fallback.</p>
      <table className="table table--cells table--light table--comfy table--striped table--responsive js-table--responsive">
        <thead>
          <tr>
            <th>Class prefix</th>
            <th>grid__col-</th>
            <th>grid__col-xs-</th>
            <th>grid__col-sm-</th>
            <th>grid__col-md-</th>
            <th>grid__col-lg-</th>
            <th>grid__col-xlg-</th>
            <th>grid__col-auto-</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Collapses at</td>
            <td>does not collapse</td>
            <td>around 480px<br/>think palm device</td>
            <td>around 768px<br/>think portrait tablet</td>
            <td>around 992px<br/>think tablet</td>
            <td>around 1200px<br/>think laptop </td>
            <td>around 1600px<br/>think desktop</td>
            <td>Dynamic sizing</td>
          </tr>
        </tbody>
      </table>
      <br/>
      <h3>Media Queries</h3>
      <p>Media queries are built using ems to be compatible with users that alter their font size and use the zoom feature.<br/>
      Use breakpoints to suit the content and not specific device sizes.
      </p>
      <pre><code className="language-css">{`@media screen and (max-width: 29.938em) { /* Insert styles */ } /* XS only */
@media screen and (min-width: 30em) and (max-width: 47.938em) { /* Insert styles */ } /* SM only */
@media screen and (min-width: 48em) { /* Insert styles */ } /* SM and up */
@media screen and (min-width: 48em) and (max-width: 61.938em) { /* Insert styles */ } /* MD only */
@media screen and (min-width: 62em) { /* Insert styles */ } /* MD and up */
@media screen and (min-width: 62em) and (max-width: 74.938em) { /* Insert styles */ } /* LG only */
@media screen and (min-width: 75em) { /* Insert styles */ } /* LG and up */
@media screen and (min-width: 100em) { /* Insert styles */ } /* XLG and up */

@media screen and (max-width: 47.938em) { /* Insert styles */ } /* 'Palm' devices */
@media screen and (max-width: 74.938em) { /* Insert styles */ } /* 'Portable' devices */
@media screen and (min-width: 75em) { /* Insert styles */ } /* 'Desktop' devices */

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx) { /* Insert styles */ } /* Retina */`}</code></pre>
  <br/><br/>
  <p>These helper classes work in conjunction with the grid breakpoints to allow finer control over elements.</p>

  <pre><code className="language-css">{`.visuallyhidden--xs-only
.visuallyhidden--sm-only
.visuallyhidden--sm-and-up
.visuallyhidden--md-only
.visuallyhidden--md-and-up
.visuallyhidden--lg-only
.visuallyhidden--lg-and-up
.visuallyhidden--xlg-and-up

.visuallyhidden--palm
.visuallyhidden--lap
.visuallyhidden--lap-and-up
.visuallyhidden--portable
.visuallyhidden--desk

.visuallyhidden--retina`}</code></pre>
<br/><br/>
      <h3>Grid modifiers</h3>
      <p>By default, the grid will wrap. You can prevent this behaviour with <code className="inline">.grid--no-wrap</code></p>
      <div className="grid grid--no-wrap sample-grid">
        <div className="grid__col-6">
          <p>these</p>
        </div>
        <div className="grid__col-6">
          <p>columns</p>
        </div>
        <div className="grid__col-10">
          <p>do not collapse</p>
        </div>
      </div>
      <br/>
      <br/>
      <p>The direction of the children can be reversed with <code className="inline">.grid--wrap-reverse</code></p>
      <div className="grid grid--wrap-reverse sample-grid">
        <div className="grid__col-6">
          <p>I am first in the markup</p>
        </div>
        <div className="grid__col-6">
          <p>I am second in the markup</p>
        </div>
        <div className="grid__col-10">
          <p>I am third in the markup</p>
        </div>
      </div>
      <br/>
      <br/>
      <h3>Cross axis modifiers</h3>
      <p>Equal height columns by default</p>
      <div className="grid sample-grid">
        <div className="grid__col-4">
          <p>First appear years night there the in them rule.</p>
        </div>
        <div className="grid__col-4">
          <p>Over after behold was living together tree is very sixth let bring fish. Forth behold they're fly deep.</p>
        </div>
        <div className="grid__col-4">
          <p>Be can't winged good for also saying first.</p>
        </div>
      </div>
      <br/>
      <br/>
      <p>'Start' aligned<code className="inline">.grid--align-start</code></p>
      <div className="grid sample-grid grid--align-start">
        <div className="grid__col-4">
          <p>First appear years night there the in them rule.</p>
        </div>
        <div className="grid__col-4">
          <p>Over after behold was living together tree is very sixth let bring fish. Forth behold they're fly deep.</p>
        </div>
        <div className="grid__col-4">
          <p>Be can't winged good for also saying first.</p>
        </div>
      </div>
      <br/>
      <br/>
      <p>'End' aligned<code className="inline">.grid--align-end</code></p>
      <div className="grid sample-grid grid--align-end">
        <div className="grid__col-4">
          <p>First appear years night there the in them rule.</p>
        </div>
        <div className="grid__col-4">
          <p>Over after behold was living together tree is very sixth let bring fish. Forth behold they're fly deep.</p>
        </div>
        <div className="grid__col-4">
          <p>Be can't winged good for also saying first.</p>
        </div>
      </div>
      <br/>
      <br/>
      <p>'Center' aligned<code className="inline">.grid--align-center</code></p>
      <div className="grid sample-grid grid--align-center">
        <div className="grid__col-4">
          <p>First appear years night there the in them rule.</p>
        </div>
        <div className="grid__col-4">
          <p>Over after behold was living together tree is very sixth let bring fish. Forth behold they're fly deep.</p>
        </div>
        <div className="grid__col-4">
          <p>Be can't winged good for also saying first.</p>
        </div>
      </div>
      <br/>
      <br/>
      <p>'Baseline' aligned<code className="inline">.grid--align-baseline</code></p>
      <div className="grid sample-grid grid--align-baseline">
        <div className="grid__col-4">
          <p style={{"fontSize":"30px", "margin":"0"}}>It makes the</p>
        </div>
        <div className="grid__col-4">
          <p style={{"fontSize":"10px", "margin":"0"}}>text all line up</p>
        </div>
        <div className="grid__col-4">
          <p style={{"fontSize":"20px", "margin":"0"}}>despite size</p>
        </div>
      </div>
      <br/>
      <br/>
      <h3>Cross axis positioning</h3>
      <p>Stretch by default</p>
      <div className="grid sample-grid sample-grid--big">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <p>Content 'start' aligned<code className="inline">.grid--align-content-start</code></p>
      <div className="grid sample-grid sample-grid--big grid--align-content-start">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <p>Content 'end' aligned<code className="inline">.grid--align-content-end</code></p>
      <div className="grid sample-grid sample-grid--big grid--align-content-end">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <p>Content 'center' aligned<code className="inline">.grid--align-content-center</code></p>
      <div className="grid sample-grid sample-grid--big grid--align-content-center">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <p>Content 'space-between' aligned<code className="inline">.grid--align-content-space-between</code></p>
      <div className="grid sample-grid sample-grid--big grid--align-content-space-between">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <p>Content 'space-around' aligned<code className="inline">.grid--align-content-space-around</code></p>
      <div className="grid sample-grid sample-grid--big grid--align-content-space-around">
        <div className="grid__col-4">
          <p>First appear</p>
        </div>
        <div className="grid__col-4">
          <p>Great blessed</p>
        </div>
        <div className="grid__col-4">
          <p>Years night</p>
        </div>
        <div className="grid__col-4">
          <p>Firmament you</p>
        </div>
        <div className="grid__col-4">
          <p>To lights</p>
        </div>
        <div className="grid__col-4">
          <p>Place good </p>
        </div>
      </div>
      <br/>
      <br/>
      <h3>Main axis alignment</h3>
      <p>'Start' aligned by default</p>
      <div className="grid sample-grid sample-grid--big">
          <div className="grid__col-4">
              <p>First appear years night there the in them rule.</p>
          </div>
          <div className="grid__col-4">
              <p>Be can't winged good for also saying first. Shall, fourth Greater cattle.</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>'End' aligned <code className="inline">.grid--justify-end</code></p>
      <div className="grid sample-grid sample-grid--big grid--justify-end">
          <div className="grid__col-4">
              <p>First appear years night there the in them rule.</p>
          </div>
          <div className="grid__col-4">
              <p>Be can't winged good for also saying first. Shall, fourth Greater cattle.</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Center aligned <code className="inline">.grid--justify-center</code></p>
      <div className="grid sample-grid sample-grid--big grid--justify-center">
          <div className="grid__col-4">
              <p>First appear years night there the in them rule.</p>
          </div>
          <div className="grid__col-4">
              <p>Be can't winged good for also saying first. Shall, fourth Greater cattle.</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Space between aligned <code className="inline">.grid--justify-space-between</code></p>
      <div className="grid sample-grid sample-grid--big grid--justify-space-between">
          <div className="grid__col-4">
              <p>First appear years night there the in them rule.</p>
          </div>
          <div className="grid__col-4">
              <p>Be can't winged good for also saying first. Shall, fourth Greater cattle.</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Space around aligned <code className="inline">.grid--justify-space-around</code></p>
      <div className="grid sample-grid sample-grid--big grid--justify-space-around">
          <div className="grid__col-4">
              <p>First appear years night there the in them rule.</p>
          </div>
          <div className="grid__col-4">
              <p>Be can't winged good for also saying first. Shall, fourth Greater cattle.</p>
          </div>
      </div>
      <br/>
      <br/>
      <h3>Direction</h3>
      <p>'Rows' by default</p>
      <div className="grid sample-grid sample-grid--big">
          <div className="grid__col-4">
              <p>I am <strong>first</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>second</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>third</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fourth</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fifth</strong> in the markup</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Row Reverse <code className="inline">.grid--direction-row-reverse</code></p>
      <div className="grid sample-grid sample-grid--big grid--direction-row-reverse">
          <div className="grid__col-4">
              <p>I am <strong>first</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>second</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>third</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fourth</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fifth</strong> in the markup</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Column <code className="inline">.grid--direction-column</code></p>
      <div className="grid sample-grid sample-grid--big grid--direction-column">
          <div className="grid__col-4">
              <p>I am <strong>first</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>second</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>third</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fourth</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fifth</strong> in the markup</p>
          </div>
      </div>
      <br/>
      <br/>
      <p>Column Reverse<code className="inline">.grid--direction-column-reverse</code></p>
      <div className="grid sample-grid sample-grid--big grid--direction-column-reverse">
          <div className="grid__col-4">
              <p>I am <strong>first</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>second</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>third</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fourth</strong> in the markup</p>
          </div>
          <div className="grid__col-4">
              <p>I am <strong>fifth</strong> in the markup</p>
          </div>
      </div>
      <br/>
      <br/>
      <h3>Ordering grid elements</h3>
      <p><code className="inline">.grid--order-&lt;n&gt;</code></p>
      <div className="grid sample-grid">
          <div className="grid__col-4 grid--order-2">
              <p>I am <strong>first</strong> in the markup but ordered second</p>
          </div>
          <div className="grid__col-4 grid--order-3">
              <p>I am <strong>second</strong> in the markup but ordered third</p>
          </div>
          <div className="grid__col-4 grid--order-1">
              <p>I am <strong>third</strong> in the markup but ordered first</p>
          </div>
      </div>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="grid">
  <div class="grid__col-4 grid--order-2">
      <p>I am <strong>first</strong> in the markup but ordered second</p>
  </div>
  <div class="grid__col-4 grid--order-3">
      <p>I am <strong>second</strong> in the markup but ordered third</p>
  </div>
  <div class="grid__col-4 grid--order-1">
      <p>I am <strong>third</strong> in the markup but ordered first</p>
  </div>
</div>`}</code></pre>
      <br/><br/>
      <h3>Advanced grid layout</h3>
      <p><code className="inline">.grid__cell-footer</code></p>
      <div className="grid sample-grid sample-grid--big">
          <div className="grid__col-12">
              <p>I am a cell</p>
              <div className="grid__cell-footer">
                  <p>I am a <strong>.grid__cell-footer</strong></p>
              </div>
          </div>
      </div>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="grid">
    <div class="grid__col-12">
        <p>I am a cell</p>
        <div class="grid__cell-footer">
            <p>I am a <strong>.grid__cell-footer</strong></p>
        </div>
    </div>
</div>`}</code></pre>
      <br/><br/>
        <p><code className="inline">.grid--bleed</code></p>
        <div className="grid grid--bleed sample-grid">
            <div className="grid__col-4">
                <p>I have no padding</p>
            </div>
            <div className="grid__col-4">
                <p>I have no padding</p>
            </div>
            <div className="grid__col-4">
                <p>I have no padding</p>
            </div>
        </div>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="grid grid--bleed">
    <div class="grid__col-4">
        <p>I have no padding</p>
    </div>
    <div class="grid__col-4">
        <p>I have no padding</p>
    </div>
    <div class="grid__col-4">
        <p>I have no padding</p>
    </div>
</div>`}</code></pre>
        <br/><br/>
        <p><code className="inline">.grid__col--bleed</code></p>
        <div className="grid sample-grid">
            <div className="grid__col-4">
                <p>Normal</p>
            </div>
            <div className="grid__col-4 grid__col--bleed">
                <p>I have no padding</p>
            </div>
            <div className="grid__col-4">
                <p>Normal</p>
            </div>
        </div>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="grid">
    <div class="grid__col-4">
        <p>Normal</p>
    </div>
    <div class="grid__col-4 grid__col--bleed">
        <p>I have no padding</p>
    </div>
    <div class="grid__col-4">
        <p>Normal</p>
    </div>
</div>`}</code></pre>
        <br/><br/>
        <p><code className="inline">.grid__cell--padding-x</code></p>
        <div className="grid sample-grid">
            <div className="grid__col-4 grid__cell--padding-sm">
                <p>padding-sm</p>
            </div>
            <div className="grid__col-4 grid__cell--padding-md">
                <p>padding-md</p>
            </div>
            <div className="grid__col-4 grid__cell--padding-lg">
                <p>padding-lg</p>
            </div>
        </div>
        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<div class="grid">
    <div class="grid__col-4 grid__cell--padding-sm">
        <p>padding-sm</p>
    </div>
    <div class="grid__col-4 grid__cell--padding-md">
        <p>padding-md</p>
    </div>
    <div class="grid__col-4 grid__cell--padding-lg">
        <p>padding-lg</p>
    </div>
</div>`}</code></pre>
        <br/><br/>
      <hr/>
    </section>
  )
}
}

export default Grid



// WEBPACK FOOTER //
// ./styleguide/components/sections/Grid.js